import { BASE_CONFIG } from "libs/config";
import { Asset } from "expo-asset";
import { Platform } from "react-native";

const getImageUrl = (val, digitalOcean = true) => {
  if (!val) {
    return;
  } else if (val.includes("data:image")) {
    return val;
  } else if (digitalOcean) return `${BASE_CONFIG.digitalOcean}/${val}`;
  return `${BASE_CONFIG.s3}/${val}`;
};

class ImageAssetHandler {
  static #instance = null;
  static images: { [key: string]: Asset } = {};

  constructor(images) {
    ImageAssetHandler.images = images;
  }

  static getInstance(images) {
    if (!ImageAssetHandler.#instance) {
      ImageAssetHandler.#instance = new ImageAssetHandler(images);
    }

    return ImageAssetHandler.#instance;
  }
}

const getFileFromUri = async (file: string): Promise<File> => {
  return new Promise(async (resolve, reject) => {
    if (Platform.OS === "web") {
      let localUri = file;
      let filename = localUri.split("/").pop();
      let match = /\.(\w+)$/.exec(filename);
      let type = match ? `image/${match[1]}` : `image`;
      const imgRes = await fetch(file);
      const blob = await imgRes.blob();
      resolve(new File([blob], filename, { type }));
    } else {
      const filename = file.split("/").pop();
      const fileUriParts = file.split(".");
      const fileExtension = fileUriParts[fileUriParts.length - 1];
      const fileMimeType = `image/${fileExtension}`;
      let imageData = {
        uri: file,
        type: fileMimeType,
        name: filename,
      };
      resolve(imageData as any);
    }
  });
};

export { getImageUrl, ImageAssetHandler, getFileFromUri };
